module.exports = __webpack_public_path__ + "static/banner-mobile-a98ac199bd13c526e666aa261bfa324a.jpg";